import type { AxiosResponse } from 'axios'
import type { QueryClient } from 'react-query'

import { zervantSettingsQueryKey } from '../../../constants/zervantSettingsQueryKey'
import type { TradeName } from '../../../types/companyValues'
import type { ZervantSettings } from '../../../types/zervantSettings'
import { getTradeNamesWithUpdatedPrimaryContact } from '../../../utils/getTradeNamesWithUpdatedPrimaryContact'
import type { PresetsSettingsFormValues } from '../types/presetsSettingsFormValues'

// Takes the caller's useQueryClient() instance: tests render with their own client, not the app singleton.
export const getPresetsSettingsTradeNames = (
  formValues: PresetsSettingsFormValues,
  queryClient: QueryClient,
): TradeName[] => {
  // tradeNames is replaced wholesale, so the company patch has to start from the cache at save time.
  const cachedSettingsResponse = queryClient.getQueryData<AxiosResponse<ZervantSettings>>(zervantSettingsQueryKey)

  if (!cachedSettingsResponse?.data) {
    throw new Error('Invoicing settings cache is empty')
  }

  return getTradeNamesWithUpdatedPrimaryContact(cachedSettingsResponse.data.values.company.tradeNames, formValues)
}
